<template>
  <v-container fluid>
    <v-list three-line>
      <template v-for="(company,index) in list">
        <div :key="index" class="mx-3 my-2">
          <v-list-tile avatar :key="index">
            <v-list-tile-avatar>
              <v-icon medium class="orange--text">$vuetify.icons.rms_company</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="subtitle-1" v-html="company.title"></v-list-tile-title>
              <v-list-tile-sub-title class="caption">
                <span>{{$t('rms.created_on')}}</span>
                &mdash; {{moment(company.created_at).format('ll')}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action class="text-xs-right">
              <v-icon
                v-if="company.id != selected_company_id "
                @click="switchCompany(company.id)"
                large
              >{{$vuetify.icons.rms_company_select_icon}}</v-icon>
              <v-icon color="green" large v-else>{{$vuetify.icons.rms_check}}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider :key="company.id" v-if="index < list.length-1" inset></v-divider>
        </div>
      </template>
    </v-list>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";

export default {
  data() {
    return {};
  },
  mounted() {
    this.setToolbarHeader();
    this.getCompanies();
  },
  computed: {
    ...mapState({
      list: state => state.company.list,
      selected_company_id: state => state.company.selected_company_id
    }),
    ...mapGetters({
      selected_company: "company/getSelectedCompany"
    })
  },
  methods: {
    async switchCompany(id) {
      await this.$store.dispatch("company/switchSelectedCompanyId", {
        selected_company_id: id
      });
      this.$store.dispatch("app/showMessage", {
        message: i18n.t("rms.company.list.when_switch_company", {
          company_name: this.selected_company.title
        }),
        color: "green"
      });
      this.$router.push({
        name: "Dashboard",
        params: {
          company_id: this.selected_company_id
        }
      });
    },

    async getCompanies() {
      this.$store.dispatch("company/list");
    },

    async setToolbarHeader() {
      await this.$store.dispatch("app/setToolbarHeader", {
        header: i18n.t("rms.toolbar.header.switch_company")
      });
    }
  }
};
</script>

